import { TranslateService } from '../Common/Services/translate.service';
import { Injectable } from '@angular/core';
import { SpaContext } from './spacontext';
import { TimeslotServiceV2, LocalityType } from '../Services/api/v2/Units/timeslot.service';
import { DropInUnitServiceV2 } from '../Services/api/v2/Units/dropIn.service';
import { ScheduledDataService } from '../Services/scheduled-data';
import { CaseApiModel } from '../Services/api/v2/Models/CaseApiModel';
import { AuthContextService } from '../Services/authContext.service';

@Injectable()
export class Doors {
	constructor(
		public _spaContext: SpaContext,
		private _dropInService: DropInUnitServiceV2,
		private _timeslotService: TimeslotServiceV2,
		private scheduledDataService: ScheduledDataService,
		private _translateService: TranslateService,
		private authContextService: AuthContextService,
	) {}

	public buildDoorsArray(doorFunctionsArray: (() => any)[]): any[] {
		let doors: any[] = [];
		for (let i in doorFunctionsArray) {
			doors.push(doorFunctionsArray[i]());
		}
		return doors;
	}

	getDropin = () => {
		return {
			icon: 'Queue',
			link: '/dropin',
			textTitle: this._translateService.get('LicenceHolder.Common.Door.Title.DropIn'),
			textObject: this.getDropinText({ text: null }),
		};
	};

	getBooking = () => {
		return {
			icon: 'Calendar2',
			link: '/booking',
			textTitle: this._translateService.get('LicenceHolder.Common.Door.Title.Booking'),
			textObject: this.getBookingText({ text: null }),
		};
	};
	getVisit = () => {
		return {
			icon: 'HandHeart',
			link: '/visits',
			textTitle: this._translateService.get('LicenceHolder.Common.Door.Title.Visits'),
			textObject: this.getVisitsText({ text: null }),
		};
	};
	getProfile = () => {
		return {
			icon: 'Avatar',
			link: '/profile',
			textTitle: this._translateService.get('LicenceHolder.Common.Door.Title.Profile'),
			textObject: this.getProfileText({ text: null }),
		};
	};
	getMessage = () => {
		return {
			icon: 'TextBubble',
			link: '/message',
			textTitle: this._translateService.get('LicenceHolder.Common.Door.Title.Message'),
			textObject: this.getMessageText({ text: '' }),
		};
	};

	private getDropinText(textObj: any) {
		this._dropInService.get().subscribe((response) => {
			let roomsOpen = 0;
			let lowestTime = Number.MAX_SAFE_INTEGER;
			let chosenIndex = 0;
			for (let i = 0; i < response.data.length; i++) {
				let time = Math.max(response.data[i].CurrentWaitTime, response.data[i].MinimumShownWaitTime);
				if (time < lowestTime) {
					lowestTime = time;
					chosenIndex = i;
				}

				if (response.data[i].IsOpen) {
					roomsOpen++;
				}
			}

			if (response.data.length === 0) {
				textObj.text = this._translateService.get('LicenceHolder.Component.Menu.Unit.DropIn.Sub.NoOpenRooms');
			} else {
				let timeText = this.getWaitTimeText(
					response.data[chosenIndex].CurrentWaitTime,
					response.data[chosenIndex].MinimumShownWaitTime,
				);

				if (roomsOpen === 0) {
					textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.DropInNone');
				} else if (roomsOpen === 1) {
					textObj.text =
						roomsOpen.toString() +
						' ' +
						this._translateService.get('LicenceHolder.Common.Door.Phrase.DropInSingular') +
						' ' +
						timeText;
				} else {
					textObj.text =
						roomsOpen.toString() + ' ' + this._translateService.get('LicenceHolder.Common.Door.Phrase.DropIn') + ' ' + timeText;
				}
			}
		});
		return textObj;
	}

	private getWaitTimeText(seconds: number, minimumShownWaitTime: number) {
		let minutes = Math.floor(seconds / 60);
		var text = minutes + ' ' + this._translateService.get('Common.Abbreviation.MinutesShort');
		if (seconds < minimumShownWaitTime + 1)
			text = Math.floor(minimumShownWaitTime / 60) + ' ' + this._translateService.get('Common.Abbreviation.MinutesShort');
		else if (minutes > 59)
			text =
				Math.floor(minutes / 60) +
				this._translateService.get('Common.Abbreviation.Hours') +
				' ' +
				(minutes % 60) +
				this._translateService.get('Common.Abbreviation.Minutes');

		return text;
	}

	private getBookingText(textObj: any) {
		this._timeslotService
			.get({
				specialityId: undefined,
				conditionId: undefined,
				resourceId: undefined,
				filterableUnitId: undefined,
				date: undefined,
				fromDate: new Date().format('yyyy-MM-dd'),
				toDate: new Date().format('yyyy-MM-dd'),
				fromTime: new Date(new Date().setHours(0, 0)).format('HH:mm:ss'),
				toTime: new Date(new Date().setHours(23, 59)).format('HH:mm:ss'),
				localityType: LocalityType.All,
			})
			.subscribe((response) => {
				let bookingsAvailable = (textObj.text = response.data.length);
				if (bookingsAvailable === 0) {
					textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.NoTimeslots');
				} else if (bookingsAvailable === 1) {
					textObj.text =
						response.data.length.toString() + ' ' + this._translateService.get('LicenceHolder.Common.Door.Phrase.BookingSingular');
				} else {
					textObj.text =
						response.data.length.toString() + ' ' + this._translateService.get('LicenceHolder.Common.Door.Phrase.Booking');
				}
			});
		return textObj;
	}

	private getVisitsText(textObj: any) {
		if (this.authContextService.isClient()) {
			this.scheduledDataService.onGetCases.subscribe((cases: Array<CaseApiModel>) => {
				const count = cases.map((c) => c.UnhandledIssues.length).reduce((a, b) => a + b, 0);
				if (count === 0) {
					textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.VisitsNoNewActivity');
				} else if (count === 1) {
					textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.VisitsNewActivitySingular', {
						number: count,
					});
				} else {
					textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.VisitsNewActivityPlural', {
						number: count,
					});
				}
			});
			this.scheduledDataService.pushCachedCases();
		} else {
			textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.VisitsLogIn');
		}
		return textObj;
	}

	private getProfileText(textObj: any) {
		if (this.authContextService.isClient()) {
			textObj.text = this.authContextService.patientIdentity.CommonName;
		} else {
			textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.ProfileLogIn');
		}
		return textObj;
	}

	private getMessageText(textObj: any) {
		if (this.authContextService.isClient()) {
			textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.Message');
		} else {
			textObj.text = this._translateService.get('LicenceHolder.Common.Door.Phrase.MessageLogIn');
		}
		return textObj;
	}
}
